import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acompanhamento-page',
  templateUrl: './acompanhamento-page.component.html',
  styleUrls: ['./acompanhamento-page.component.css']
})
export class AcompanhamentoPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
